import {
  BatteryCharging,
  BriefcaseBusiness,
  CalendarHeart,
  Flag,
  PiggyBank,
  Rocket,
} from "lucide-react";

export const budgetConfigs = {
  "uk-budget-planner": {
    id: "uk-budget-planner",
    title: "UK Budget Planner",
    eyebrow: "Household planning",
    description: "Plan monthly income, essential spending, lifestyle costs, savings, and remaining money.",
    incomeLabel: "Monthly take-home income",
    period: "month",
    defaultIncome: 3200,
    categories: [
      ["Rent or mortgage", 1100],
      ["Council tax", 160],
      ["Utilities", 220],
      ["Groceries", 420],
      ["Transport", 240],
      ["Insurance", 95],
      ["Subscriptions", 55],
      ["Savings", 350],
      ["Lifestyle", 300],
    ],
    recommendationType: "personal",
  },
  "marriage-budget-calculator": {
    id: "marriage-budget-calculator",
    title: "Marriage Budget Calculator",
    eyebrow: "Wedding costs",
    description: "Estimate ceremony, venue, outfits, suppliers, honeymoon, and contingency in one view.",
    incomeLabel: "Total wedding budget",
    period: "event",
    defaultIncome: 18000,
    categories: [
      ["Venue", 6500],
      ["Catering", 4200],
      ["Photography", 1800],
      ["Outfits", 1600],
      ["Flowers and decor", 900],
      ["Entertainment", 1200],
      ["Stationery", 300],
      ["Honeymoon", 2500],
      ["Contingency", 1000],
    ],
    recommendationType: "event",
  },
  "business-budget-calculator": {
    id: "business-budget-calculator",
    title: "Business Budget Calculator",
    eyebrow: "Operating budget",
    description: "Plan monthly revenue against payroll, software, marketing, premises, tax set-aside, and profit.",
    incomeLabel: "Expected monthly revenue",
    period: "month",
    defaultIncome: 12000,
    categories: [
      ["Payroll or owner pay", 4200],
      ["Software", 480],
      ["Marketing", 1200],
      ["Premises", 1500],
      ["Professional fees", 450],
      ["Insurance", 180],
      ["Travel", 350],
      ["Tax set-aside", 1800],
      ["Profit reserve", 1400],
    ],
    recommendationType: "business",
  },
  "startup-expense-calculator": {
    id: "startup-expense-calculator",
    title: "Start Up Expense Calculator",
    eyebrow: "Launch costs",
    description: "Estimate one-off launch costs before opening: equipment, legal, marketing, stock, and runway.",
    incomeLabel: "Available startup budget",
    period: "launch",
    defaultIncome: 25000,
    categories: [
      ["Company setup and legal", 900],
      ["Equipment", 4200],
      ["Website and brand", 1800],
      ["Initial marketing", 3500],
      ["Stock or materials", 5000],
      ["Software setup", 900],
      ["Professional services", 1600],
      ["First 3 months runway", 5200],
      ["Contingency", 1900],
    ],
    recommendationType: "startup",
  },
};

export const planningCards = [
  {
    id: "uk-budget-planner",
    title: "UK Budget Planner",
    eyebrow: "Personal budget",
    description: "Build a monthly UK budget with spending categories, chart breakdowns, and recommendations.",
    path: "/planning/uk-budget-planner",
    action: "Plan budget",
    Icon: PiggyBank,
  },
  {
    id: "marriage-budget-calculator",
    title: "Marriage Budget Calculator",
    eyebrow: "Wedding planner",
    description: "Estimate wedding costs by category and see where the budget is tight or flexible.",
    path: "/planning/marriage-budget-calculator",
    action: "Calculate wedding",
    Icon: CalendarHeart,
  },
  {
    id: "business-budget-calculator",
    title: "Business Budget Calculator",
    eyebrow: "Operating plan",
    description: "Compare monthly revenue with operating spend, tax set-aside, and profit reserve.",
    path: "/planning/business-budget-calculator",
    action: "Plan business",
    Icon: BriefcaseBusiness,
  },
  {
    id: "startup-expense-calculator",
    title: "Start Up Expense Calculator",
    eyebrow: "Launch plan",
    description: "Estimate the cash needed to launch and identify gaps before committing spend.",
    path: "/planning/startup-expense-calculator",
    action: "Estimate startup",
    Icon: Rocket,
  },
  {
    id: "goal-productivity-calculator",
    title: "Goal & Productivity Calculator",
    eyebrow: "Execution plan",
    description: "Turn a target into daily milestones and score focus quality, distractions, and output.",
    path: "/planning/goal-productivity-calculator",
    action: "Plan goal",
    Icon: Flag,
  },
  {
    id: "digital-detox-calculator",
    title: "Digital Detox Calculator",
    eyebrow: "Time reclaimed",
    description: "Calculate how much time you can save each week, month, and year by cutting screen time.",
    path: "/planning/digital-detox-calculator",
    action: "Calculate detox",
    Icon: BatteryCharging,
  },
];